import { createUseStyles } from 'react-jss'

export const useStyle = createUseStyles({
  socialIcon: {
    width: 32,
    height: 32,
    borderRadius: 32
  }
})
